import {
    IonButton,
    IonButtons,
    IonContent,
    IonFooter,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonModal,
    IonRadio,
    IonRadioGroup,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setCreatedByFilter,
    setFilterByCreatedModal
} from "../../../store/documentsSignerList";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { selectFilterByCreatedModal } from "../../../store/documentsSignerList/selectors/selectFilterByCreatedModal";

export const FilterCreatedBySelector: React.FC = () => {
  const dispatch = useDispatch();

  const showModal = useSelector(selectFilterByCreatedModal);
  const [selected, setSelected] = useState<string>("all");

  const applyFilter = async () => {
    dispatch(setCreatedByFilter(selected));
    dispatch(setFilterByCreatedModal(false));

    dispatch(fetchDocuments());
  };

  const resetFilter = () => {
    dispatch(setCreatedByFilter("all"));
    dispatch(setFilterByCreatedModal(false));
    dispatch(fetchDocuments());
  };

  return (
    <>
      <IonModal isOpen={showModal} onDidDismiss={() => dispatch(setFilterByCreatedModal(false))}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por autor del documento</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setFilterByCreatedModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Autor del documento:</IonListHeader>
            <IonRadioGroup value={selected} onIonChange={(e) => setSelected(e.detail.value)}>
              <IonItem>
                <IonLabel>Yo</IonLabel>
                <IonRadio slot="end" value="me" />
              </IonItem>
              <IonItem>
                <IonLabel>Todos</IonLabel>
                <IonRadio slot="end" value="all" />
              </IonItem>
            </IonRadioGroup>
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
